// For more information about this file see https://dove.feathersjs.com/guides/cli/service.shared.html
import type { Params } from '@feathersjs/feathers'
import type { ClientApplication } from '../../client'
import type {
  WebEmailSubmission,
  WebEmailSubmissionData,
  WebImageAttachment,
  WebEmailSubmissionQuery,
  WebEmailSubmissionService
} from './web-email-submission.class'

export type { WebEmailSubmission, WebEmailSubmissionData, WebImageAttachment, WebEmailSubmissionQuery }

export type WebEmailSubmissionClientService = Pick<WebEmailSubmissionService<Params<WebEmailSubmissionQuery>>, (typeof webEmailSubmissionMethods)[number]>

export const webEmailSubmissionPath = 'api/web-email-submission'

export const webEmailSubmissionMethods: Array<keyof WebEmailSubmissionService> = ['create']

export const webEmailSubmissionClient = (client: ClientApplication) => {
  const connection = client.get('connection')

  client.use(webEmailSubmissionPath, connection.service(webEmailSubmissionPath), {
    methods: webEmailSubmissionMethods
  })
}

// Add this service to the client service type index
declare module '../../client' {
  interface ServiceTypes {
    [webEmailSubmissionPath]: WebEmailSubmissionClientService
  }
}
